import { useQuery, useQueryClient } from '@tanstack/react-query';

import type { AgentsBoard, Proposal } from '../../api/agentSchemas';
import { getAgentsBoard } from '../../api/endpoints/agents';

export const AGENTS_BOARD_KEY = ['agents-board'] as const;
/** The board recomputes the whole 90-day picture, so the nav badge does not ask more often than this. */
const BOARD_STALE_MS = 5 * 60_000;

export function useAgentsBoard(enabled = true) {
  return useQuery({ queryKey: AGENTS_BOARD_KEY, queryFn: getAgentsBoard, enabled, staleTime: BOARD_STALE_MS });
}

/** Puts the server's copy of one proposal into the cached board, then refreshes agent statuses behind it. */
export function useReplaceProposal(): (proposal: Proposal) => void {
  const queryClient = useQueryClient();
  return (proposal) => {
    queryClient.setQueryData<AgentsBoard>(AGENTS_BOARD_KEY, (board) =>
      board
        ? { ...board, proposals: board.proposals.map((current) => (current.id === proposal.id ? proposal : current)) }
        : board,
    );
    void queryClient.invalidateQueries({ queryKey: AGENTS_BOARD_KEY });
  };
}

export function pendingCount(board: AgentsBoard | undefined): number {
  return board?.proposals.filter((proposal) => proposal.status === 'pending').length ?? 0;
}
